import { EnglishStr } from "@/lib/EnglishStr";
import ErrorTemplate from "./ErrorTemplate";
import { RootState } from "@/store/dtm";
import { useSelector } from "react-redux";

export default function BlocklistError() {
  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const product = application.selectedProducts[0].description;
  return (
    <ErrorTemplate
      //TODO:add dynamic product
      title="Thank you for your application."
      content={
        <>
          We regret to inform you that your application has been unsuccessful as
          it does not meet our{" "}
            <b className="brand-blue-text">{product}</b>
          {" "}
          opening criteria. If you have any questions, please call our Member
          Service Team at
          <a href={"tel:" + EnglishStr.ContactCentrePhone} target="_blank">
            {" "}
            <span className="active underline">
              {EnglishStr.ContactCentrePhone}.
            </span>
          </a>
        </>
      }
    />
  );
}
